import {
    CORE_LOAD_SITE_REQUEST,
    CORE_LOAD_SITE_SUCCESS,
    CORE_LOAD_SITE_FAILURE,

    CORE_LOAD_SITE_BY_ID_REQUEST,
    CORE_LOAD_SITE_BY_ID_SUCCESS,
    CORE_LOAD_SITE_BY_ID_FAILURE,

    CORE_CHANGE_IMG_SITE_REQUEST,
    CORE_CHANGE_IMG_SITE_SUCCESS,
    CORE_CHANGE_IMG_SITE_FAILURE,

    CORE_API_AIR_REQUEST,
    CORE_API_AIR_SUCCESS,
    CORE_API_AIR_FAILURE,

    CORE_API_AIR_WIND_REQUEST,
    CORE_API_AIR_WIND_SUCCESS,
    CORE_API_AIR_WIND_FAILURE,

    CORE_API_AIR_17_REQUEST,
    CORE_API_AIR_17_SUCCESS,
    CORE_API_AIR_17_FAILURE,

    CORE_API_AIR_WIND_17_REQUEST,
    CORE_API_AIR_WIND_17_SUCCESS,
    CORE_API_AIR_WIND_17_FAILURE,

    CORE_API_AIR_PRESSURE_17_REQUEST,
    CORE_API_AIR_PRESSURE_17_SUCCESS,
    CORE_API_AIR_PRESSURE_17_FAILURE,

    CORE_API_AIR_CLOUD_17_REQUEST,
    CORE_API_AIR_CLOUD_17_SUCCESS,
    CORE_API_AIR_CLOUD_17_FAILURE,

    CORE_API_AIR_PRESSURE_REQUEST,
    CORE_API_AIR_PRESSURE_SUCCESS,
    CORE_API_AIR_PRESSURE_FAILURE,

    CORE_API_AIR_CLOUD_REQUEST,
    CORE_API_AIR_CLOUD_SUCCESS,
    CORE_API_AIR_CLOUD_FAILURE,


} from '../../types';
import { REQUEST_STATE } from '../../types';

const requestState = REQUEST_STATE;

export default {
    sites: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_SITE_REQUEST:
                return state;
            case CORE_LOAD_SITE_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case CORE_LOAD_SITE_FAILURE:
                return [];
            default:
                return state;
        }
    },
    site: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_SITE_BY_ID_REQUEST:
                return state;
            case CORE_LOAD_SITE_BY_ID_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload;
                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case CORE_LOAD_SITE_BY_ID_FAILURE:
                return {};
            default:
                return state;
        }
    },
    siteChangeImg: (state = requestState, action) => {
        switch (action.type) {
            case CORE_CHANGE_IMG_SITE_REQUEST:
                return state;
            case CORE_CHANGE_IMG_SITE_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload;
                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case CORE_CHANGE_IMG_SITE_FAILURE:
                return {};
            default:
                return state;
        }
    },
    apiDataReportAir: (state = requestState, action) => {
        switch (action.type) {
            case CORE_API_AIR_REQUEST:
                return state;
            case CORE_API_AIR_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        console.log('test fon datas')
                        return datas;
                    } else return {};
                } else {
                    return {};
                }
            case CORE_API_AIR_FAILURE:
                return {};
            default:
                return state;
        }
    },
    apiDataReportAirWind: (state = requestState, action) => {
        switch (action.type) {
            case CORE_API_AIR_WIND_REQUEST:
                return state;
            case CORE_API_AIR_WIND_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        console.log('test fon datas')
                        return datas;
                    } else return {};
                } else {
                    return {};
                }
            case CORE_API_AIR_WIND_FAILURE:
                return {};
            default:
                return state;
        }
    },
    apiDataReportAirPressure: (state = requestState, action) => {
        switch (action.type) {
            case CORE_API_AIR_PRESSURE_REQUEST:
                return state;
            case CORE_API_AIR_PRESSURE_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return {};
                } else {
                    return {};
                }
            case CORE_API_AIR_PRESSURE_FAILURE:
                return {};
            default:
                return state;
        }
    },
    apiDataReportAir17: (state = requestState, action) => {
        switch (action.type) {
            case CORE_API_AIR_17_REQUEST:
                return state;
            case CORE_API_AIR_17_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return {};
                } else {
                    return {};
                }
            case CORE_API_AIR_17_FAILURE:
                return {};
            default:
                return state;
        }
    },
    apiDataReportAirWind17: (state = requestState, action) => {
        switch (action.type) {
            case CORE_API_AIR_WIND_17_REQUEST:
                return state;
            case CORE_API_AIR_WIND_17_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        console.log('test fon datas17')
                        return datas;
                    } else return {};
                } else {
                    return {};
                }
            case CORE_API_AIR_WIND_17_FAILURE:
                return {};
            default:
                return state;
        }
    },
    
    apiDataReportAirPressure17: (state = requestState, action) => {
        switch (action.type) {
            case CORE_API_AIR_PRESSURE_17_REQUEST:
                return state;
            case CORE_API_AIR_PRESSURE_17_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return {};
                } else {
                    return {};
                }
            case CORE_API_AIR_PRESSURE_17_FAILURE:
                return {};
            default:
                return state;
        }
    },
    apiDataReportAirCloud17: (state = requestState, action) => {
        switch (action.type) {
            case CORE_API_AIR_CLOUD_17_REQUEST:
                return state;
            case CORE_API_AIR_CLOUD_17_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return {};
                } else {
                    return {};
                }
            case CORE_API_AIR_CLOUD_17_FAILURE:
                return {};
            default:
                return state;
        }
    },
    apiDataReportAirCloud: (state = requestState, action) => {
        switch (action.type) {
            case CORE_API_AIR_CLOUD_REQUEST:
                return state;
            case CORE_API_AIR_CLOUD_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return {};
                } else {
                    return {};
                }
            case CORE_API_AIR_CLOUD_FAILURE:
                return {};
            default:
                return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/masterData/site.js